module.exports = "/assets/data/f37613a6aa58994ac0e03129fcaee91b-HS8.data.json";